import io from "socket.io-client";
import feathers from "@feathersjs/feathers";
import socketio from "@feathersjs/socketio-client";
import auth from "@feathersjs/authentication-client";

let serverUrl = process.env.REACT_APP_SERVER_API;
// let collabUrl;
let portData = process.env.REACT_APP_PORT_DATA.split(",");

/*** code to enable online (FOR ONLINE BUILD) ***/
// sessionStorage.setItem("media_url", process.env.REACT_APP_ASSET_MEDIA);


// console.log("====>>>", process.env.REACT_APP_PORTS_DATA);
let ports = portData;

/*** code to enable env IP (FOR ONLINE BUILD) ***/
let server = serverUrl + ":" + ports[Math.floor(Math.random() * ports.length)];
console.log("Server URL: ", server);
const socket = io(server, {
  transports: ["websocket"],
  extraHeaders: {
    "x-access-token": "YRS/DzcxC0+58jfh/kphhA6zz4Y=",
  },
  rejectUnauthorized: false
});

const client = feathers();

client.configure(
  socketio(socket, {
    timeout: 2000000,
  })
);

// socket.on('connect_error', console.error)
// socket.on('error', console.error)


client.configure(
  auth({
    storage: window.localStorage,
    storageKey: "feathers-jwt",
  })
);

console.log("Got a feathers-client.js!");

export default client;
